import React, { useMemo, useCallback } from 'react';
import { Text } from 'react-native';
// html-react-parser ships its own types; import default
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import parse from 'html-react-parser';
import { useEventRsvp } from '@/hooks/residents/useEventRsvp';
import { Event } from '@/types/residents/event';
import { RNButton } from '@/components/common/residents/desktop/Button';
import AddToCalendarButton from '@/components/common/residents/desktop/AddToCalendarButton.web';
import DesktopEventCardBase from '@/components/residents/events/desktop/DesktopEventCardBase';
import { formatEventDate, formatEventTimeRange } from '@/utils/residents/events/date';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { useToast } from '@/contexts/admin/ToastContext';
import { eventStrings } from '@/constants/residents/strings';

interface Props { event: Event }

export const DesktopEventCard: React.FC<Props> = ({ event }) => {
  const { showSuccess } = useToast();
  const imageUrl = event?.photos && event.photos.length > 0 ? event.photos[0]?.photoUrl : undefined;
  const dateText = useMemo(() => formatEventDate(event?.startTime), [event?.startTime]);
  const timeRange = useMemo(() => formatEventTimeRange(event?.startTimeLocal || event?.startTime, event?.endTimeLocal || event?.endTime), [event?.startTimeLocal, event?.endTimeLocal, event?.startTime, event?.endTime]);

  const { accept: onAccept, decline: onDecline, isUpdating } = useEventRsvp(event, {
    acceptSuccessMessage: eventStrings?.rsvp?.success || 'Attendance confirmed',
    declineSuccessMessage: 'Attendance updated',
  });

  const descriptionNode = !!(event?.descriptionHTML || event?.description || event?.responseDescription) ? (
    event?.descriptionHTML ? (
      <>{parse(event.descriptionHTML)}</>
    ) : (
      <Text style={{ color: '#A7ABB1', fontSize: 14, lineHeight: 18, marginTop: 8 }} numberOfLines={8}>
        {event.description || event.responseDescription}
      </Text>
    )
  ) : null;

  const actions = (
    <>
      {!event?.rsvp && (
        <RNButton title="I will attend" onPress={onAccept} variant="tertiary" size="md" disabled={isUpdating} />
      )}
      {event?.rsvp && (
        <RNButton
          title={"I can't attend"}
          onPress={onDecline}
          variant="link"
          size="md"
          disabled={isUpdating}
          style={{
            backgroundColor: 'transparent',
            borderWidth: 1,
            borderColor: RESIDENTS_DESKTOP_COLORS.BUTTON_TERTIARY,
            borderRadius: 8,
            paddingVertical: 10,
            paddingHorizontal: 16,
          }}
          textStyle={{ color: RESIDENTS_DESKTOP_COLORS.BUTTON_TERTIARY, fontWeight: '700' }}
        />
      )}
      <AddToCalendarButton calendarEvent={event} />
    </>
  );

  return (
    <DesktopEventCardBase
      event={event}
      imageUrl={imageUrl}
      dateText={dateText}
      timeRange={timeRange}
      descriptionNode={descriptionNode}
      actions={actions}
    />
  );
};
export default DesktopEventCard;


